import { render, staticRenderFns } from "./WonderfulVideo.vue?vue&type=template&id=31ddab7c&scoped=true"
import script from "./WonderfulVideo.vue?vue&type=script&lang=js"
export * from "./WonderfulVideo.vue?vue&type=script&lang=js"
import style0 from "./WonderfulVideo.vue?vue&type=style&index=0&id=31ddab7c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ddab7c",
  null
  
)

export default component.exports